if (!customElements.get('lookstan-variant-help')) {
  customElements.define('lookstan-variant-help', class extends HTMLElement {
    connectedCallback() {
      this.data = JSON.parse(this.querySelector('script').textContent);
      this.scope = this.closest('product-info');
      if (!this.scope) return;
      this.refresh = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.render());
      };
      this.scope.addEventListener('change', this.refresh);
      this.observer = new MutationObserver(records => { if (records.some(r => !this.contains(r.target))) this.refresh(); });
      this.observer.observe(this.scope, {subtree:true,childList:true,attributes:true,attributeFilter:['value','disabled']});
      this.render();
    }
    disconnectedCallback() { this.observer?.disconnect(); this.scope?.removeEventListener('change',this.refresh); cancelAnimationFrame(this.frame); }
    render() {
      const id = this.scope.querySelector('form[data-type="add-to-cart-form"] input[name="id"]')?.value;
      const selected = this.data.variants.find(v => String(v.id) === id);
      const size = this.data.options.findIndex(o => /^(size|مقاس)$/i.test(o));
      if (!selected || selected.available || size < 0) { this.hidden = true; return; }
      const alternatives = this.data.variants.filter(v => v.available && v.options.every((value,i) => i === size || value === selected.options[i]));
      this.hidden = alternatives.length === 0;
      const target = this.querySelector('[data-alternatives]');
      target.replaceChildren(...alternatives.map(v => {
        const a = document.createElement('a');
        a.href = this.dataset.url + '?variant=' + v.id;
        a.textContent = v.options[size];
        return a;
      }));
    }
  });
}
if (!customElements.get('lookstan-cart-edit')) {
  customElements.define('lookstan-cart-edit', class extends HTMLElement {
    connectedCallback() {
      this.variants = JSON.parse(this.querySelector('script').textContent);
      this.selects = [...this.querySelectorAll('select')];
      this.button = this.querySelector('[data-save-edit]');
      this.status = this.querySelector('[data-edit-status]');
      this.addEventListener('change', e => { e.stopPropagation(); this.sync(); });
      this.button.addEventListener('click', () => this.save());
      this.sync();
    }
    sync() {
      this.variant = this.variants.find(v => v.options.every((value,i) => value === this.selects[i].value));
      this.button.disabled = !this.variant?.available || String(this.variant.id) === this.dataset.variant;
      this.status.hidden = !!this.variant?.available;
    }
    async request(path, body) {
      const response = await fetch((window.Shopify?.routes?.root || '/') + path, body ? {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)} : {cache:'no-store'});
      const data = await response.json();
      if (!response.ok || data.errors) throw new Error(data.description || data.message || this.dataset.error);
      return data;
    }
    async save() {
      if (this.button.disabled || this.busy) return;
      this.busy = true; this.button.disabled = true;
      const label = this.button.textContent;
      this.button.textContent = this.dataset.loading;
      this.selects.forEach(s => s.disabled = true);
      try {
        const before = await this.request('cart.js');
        const original = before.items.find(item => item.key === this.dataset.key);
        if (!original) throw new Error(this.dataset.error);
        const addition = {id:this.variant.id,quantity:original.quantity,properties:original.properties || {}};
        if (original.selling_plan_allocation) addition.selling_plan = original.selling_plan_allocation.selling_plan.id;
        await this.request('cart/add.js',{items:[addition]});
        const after = await this.request('cart.js');
        const same = item => item.variant_id === original.variant_id && JSON.stringify(item.properties || {}) === JSON.stringify(original.properties || {}) && item.selling_plan_allocation?.selling_plan.id === original.selling_plan_allocation?.selling_plan.id;
        let remaining = original.quantity;
        const updates = {};
        const matches = after.items.filter(same).sort((a,b) => Number(b.key === original.key)-Number(a.key === original.key));
        for (const item of matches) { const remove = Math.min(remaining,item.quantity); updates[item.key] = item.quantity-remove; remaining -= remove; if (!remaining) break; }
        if (remaining) throw new Error(this.dataset.error);
        const drawer = document.querySelector('cart-drawer');
        const cartItems = this.closest('cart-items, cart-drawer-items');
        const sections = cartItems.getSectionsToRender();
        const result = await this.request('cart/update.js',{updates,sections:sections.map(s=>s.section),sections_url:location.pathname});
        for (const section of sections) {
          const html = result.sections?.[section.section];
          if (!html) { location.reload(); return; }
          const source = new DOMParser().parseFromString(html,'text/html').querySelector(section.selector);
          const host = document.getElementById(section.id);
          const target = host?.querySelector(section.selector) || host;
          if (source && target) target.innerHTML = source.innerHTML;
        }
        if (drawer?.classList.contains('active')) trapFocus(drawer.querySelector('.drawer__inner'),drawer.querySelector('.drawer__close'));
        publish(PUB_SUB_EVENTS.cartUpdate,{source:'cart-items',cartData:result});
      } catch (error) {
        this.status.textContent = this.dataset.error;
        this.status.hidden = false;
      } finally {
        this.busy = false;
        this.button.textContent = label;
        this.selects.forEach(s => s.disabled = false);
        this.button.disabled = false;
      }
    }
  });
}
